<template>
  <div>
    <router-view
      :env="env"
      :permissions="permissions"
      :globals="globals"
      :userInfo="userInfo ? userInfo : {}"
      :overduePayments="alerts.overduePayments ? alerts.overduePayments : []"
      :upcomingPayments="alerts.upcomingPayments ? alerts.upcomingPayments : []"
      :generalAlerts="alerts.generalAlerts ? alerts.generalAlerts : []"
      :properties="properties"
      :payments="payments"
      :rentals="rentals"
      :propList="propList"
      :registeredGuests="registeredGuests"
      :loading="loading"

      @refresh-alerts="$emit('refresh-alerts')"
      @refresh-rentals="$emit('refresh-rentals')"
      @refresh-prop-list="$emit('refresh-prop-list')"
      @refresh-payments="$emit('refresh-payments')"
      @refresh-registered-guests="$emit('refresh-registered-guests')"
      @refresh-userinfo="$emit('refresh-userinfo')"
      @refresh-properties="$emit('refresh-properties')"
      @success="$emit('success', $event)"
      @success-banner="$emit('success-banner', $event)"
      @error="$emit('error', $event)"
      @error-banner="$emit('error-banner', $event)"
      @info="$emit('info', $event)"
      @background="$emit('background', $event)"
      @loading="$emit('loading', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'Manager',

  props: {
    env: {
      type: Object,
      required: true,
    },

    permissions: {
      type: Number,
      required: true,
      default: 0,
    },

    globals: {
      type: Object,
      required: false,
    },

    userInfo: {
      type: Object,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
      default: [],
    },

    alerts: {
      type: Object,
      required: true,
    },

    rentals: {
      type: Array,
      required: true,
    },

    propList: {
      type: Array,
      required: true,
    },

    payments: {
      type: Array,
      required: true,
    },

    registeredGuests: {
      type: Array,
      required: false,
      default: () => [],
    },

    loading: {
      type: Boolean,
      required: true,
    },
  },

  watch: {

  },

  data: () => ({

  }),

  methods: {

  },

  mounted() {

  },
};
</script>
